var localeValues = {
  home: {
    // 总览
    overview: 'Home',
    industry: 'Industry Solutions',
    market: 'Algorithm Mall',
    contact: 'Contact Us',
    login: 'Log In',
    register: 'Register',
    //算法超市
    detection: 'Face Detection',
    landmarks: 'Facial Landmarks',
    comparison: 'Face Comparison',
    album: 'Album Clustering',
    emotion: 'Emotion Recognition',
    attributes: 'Face Attributes',
    age: 'Age and Gender',
    mask: 'Mask Detection',
    portrait: 'Portrait Segmentation',
    beauty: 'Beauty Score',
    head: 'Head and Shoulder Detection',
    gender: 'Gender Recognition',

    body: 'Human Body Detection',
    bodyAttributes: 'Body Attributes',
    skeleton: 'Skeleton Keypoints',
    hand: 'Hand Keypoints',
    recognition: 'Hand Gesture Recognition',
    crowd: 'Crowd Density',
    driving: 'Driving Behavior Analysis',
    reflective: 'Reflective Clothing Detection',

    general: 'General Text Recognition',
    handwritten: 'Handwritten Text Recognition',
    bank: 'Bank Card Recognition',
    business: 'Business License Recognition',
    License: 'Vehicle License Plate Recognition',
    table: 'Table Recognition',
    office: 'Office Document Recognition',
    qr: 'QR Code Recognition',
    invoice: 'Invoice Information Extraction',
    driver: 'Driver License Recognition',
    fight: 'Fight',
    matting: 'Body Matting',

    image: 'General Image Recognition',
    plant: 'Plant Recognition',
    animal: 'Animal Recognition',
    car: 'Car Model Recognition',
    vehicle: 'Vehicle Detection',
    food: 'Food Recognition',
    fruit: 'Fruit And Vegetable Recognition',
    fire: 'Fire Recognition',
    smoke: 'Smoke Recognition',
    landmark: 'Landmark Recognition',
    pet: 'Pet Comparison',

    super: 'Super Resolution',
    Inpainting: 'Image Inpainting',
    dehazing: 'Dehazing',
    style: 'Image Style Transfer',
    anime: 'Anime Style Portrait',
    search: 'Image Search',
    product: 'Product Search',
    generation: 'Image Generation',
    color: 'Color Enhancement',
    black: 'Black and White Image Coloring',

    face: 'Face Recognition',
    bodyRecognition: 'Body Recognition',
    characterRecognition: 'Character Recognition',
    imageRecognition: 'Image Recognition',
    imageTechnology: 'Image Technology',

    title: 'Smart AI Visual Inspection Platform',
    description: 'Let defects hide nowhere, industry leaders choose only!',
    start: 'Get Started',
    learnMore: 'Learn More',
    aIot: 'AIot Intelligence connects all things',
    twoDescription:
      'Crafted with ingenuity to create globally leading intelligent solutions',

    audioTech: 'Voice Technology',
    denoising: 'Pectorophony',
    voice: 'Voice Wake-Up',
    generalText:
      'Universal text recognition technology converts text in pictures into editable text.',
    algorithmic: 'Algorithmic',
    faceAgeDec:
      'Age recognition is the use of techniques such as image analysis to estimate a person age.',
    customer: 'Customer Attribute Analysis',
    camera: 'Beauty Camera',
    ageText: 'age',
    genderDec:
      'Gender identification is the use of techniques such as image analysis to determine a person gender',
    genderText: 'gender',
    emotionDec:
      'Emotion recognition is a method that uses techniques such as image analysis to judge a persons emotions.',
    emotionText: 'emotion',
    richness: 'Recognition Type Richness',
    analysis: 'Support For Real-time Analysis',
    comparisonDec:
      'Face comparison is the process of using algorithms to analyze and compare feature points of different face images to determine identity similarity.',
    access: 'Access Control System',
    security: 'Security And Protection Monitoring',
    petDec:
      'Pet detection is the process of using algorithms to analyze and compare feature points of different face images to determine identity similarity.',
    insurance: 'Pet Insurance',
    facial: 'facial recognition',
    expression: 'facial expression analysis',
    bodyDec:
      'Human detection technology is used to identify the outline and position of a human body in an image or video.',
    warning: 'Security Monitoring And Early Warning',
    bodyText: 'Gender',
    skeletonDec:
      'Description of human skeleton points: head, neck, shoulder, elbow, wrist, hand, chest, waist, hip, knee, ankle, foot and other joints.',
    fallDown: 'Fall down detection',
    motion: 'Motion capture technology',
    bodyAttributesDec:
      'Human body attribute recognition description: through the image analysis of gender, age, posture, clothing and behavior characteristics',
    crowd: 'Crowd attribute identification',
    retail: 'Retail Customer Analysis',
    satisfaction: 'Analysis Of Satisfaction Degree',
    flow: 'Count the flow of people',
    advertisement: 'Advertisement Putting',
    keyIndex: 'Key Indicator',
    indexDec:
      'In algorithm deployment, the choice of hardware platform directly affects the efficiency and cost',
    face_tips:
      'At present, the page displays a maximum of 10 results, which can be displayed using the SDK',
    readAgree: 'I have read and agreed',
    userAgree: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    and: 'and',
    qr: 'QuickMark',
    qrDec:
      'The technology of quickly reading two-dimensional code information through the device',
    qrResult: 'Analysis Result',
    pay: 'Scan To Pay',
    plate: 'Vehicle License Plate Recognition',
    plateDec:
      'Universal text recognition technology can convert text in pictures into editable text',
    parking: 'Pay For Unattended Parking Lot',
    traffic: 'Traffic Violation Monitoring',
    vehicle: 'Detecting Test Of Vehicle',
    vehicleDec:
      'Use technology to identify and analyze the situation of vehicles on the road',
    flow: 'Road Traffic Flow Statistics',
    error: 'Sorry, the page you visited does not exist.',
    backHome: 'Back Home',
    qrEmpty: 'No QR code was detected',
    selectQr: 'Please select again to ensure that the QR code is on the screen',
    plateEmpty: 'No license plate was detected',
    selectPlate:
      'Please select again to make sure the plate is facing the screen',
    vehicleEmpty: 'No vehicle was detected',
    handleEmpty: 'No hand was detected',
    selectVehicle:
      'Please re-select to ensure that the vehicle is facing the screen',
    human: 'Human Body Keying Image',
    humanDec:
      'Accurately extract the outline of a person in a video or image and remove the background',
    broadcast: 'Virtual Live Broadcast',
    video: 'Videoconferencing',
    audio: 'Audio noise reduction',
    audioDec:
      'Intelligently eliminates background noise and enhances the clarity of human voice.',
    before: 'Before',
    after: 'After',
    noise: 'Headphone noise reduction',
    restore: 'High definition restoration',
    restoreDec:
      'Restores detail to low-resolution images or videos to improve clarity.',
    film: 'Film And Television Restoration',
    animation: 'Character Animation',
    animationDec:
      'The process of converting images of real people into anime style.',
    character: 'Character Development',
    handkey: 'Gesture Key Point',
    handKeyDec:
      'Identify and track key position points of hand movements for interactive control.',
    game: 'Motion Sensing Game',
    density: 'Crowd Density',
    densityDec:
      'To monitor and analyze the number and distribution of people in a specific area through technical means.',
    shopping: 'Shopping Mall Management',
    person: 'person',
    selectHand: 'Please reselect to make sure the gesture is facing the screen',
    selectVehicle:
      'Please re-select to ensure that the vehicle is facing the screen',
    helmet: 'helmet',
    maskTest: 'maskDetection',
    maskTestDec:
      'Image recognition technology is used to determine whether a person is wearing a mask correctly',
    wearApply: 'Medical Supplies Wear Testing',
    maskEmpty: 'No masks were detected',
    selectMask:
      'Please select again to make sure the mask is facing the screen',
    behavior: 'Driving Behavior Analysis',
    behaviorDec:
      'Analyze driver operation and status through image recognition technology',
    behaviorApply: 'Fatigue Driving Warning',
    helmet: 'Safety Helmet Detection',
    helmetDec:
      'Determine whether the person is wearing the helmet correctly through image recognition technology.',
    helmetApply: 'Site Safety Management',
    helmetEmpty: 'No hard hats were detected',
    selectHelmet:
      'Please select again and make sure the helmet is facing the screen',
    fireEmpty: 'No fire was detected',
    selectFire: 'Please re-select to ensure that the fire is facing the screen',
    businessDec:
      'Automatically extract certificate information through image recognition technology to improve audit efficiency.',
    businessApply: 'Business Registration',
    bankDec:
      'Bank card information is automatically extracted through image recognition technology.',
    bankApply: 'Bank Transfer',
    invoiceDec:
      'Key information on invoices is automatically extracted through image recognition technology.',
    invoiceApply1: 'Corporate Reimbursement',
    invoiceApply2: 'Tax Audit',
    driverDec:
      'The driver license information is automatically extracted by image recognition technology.',
    driverApply: 'Traffic Police Check',
    depth: 'Depth Estimation',
    odd: 'Odd Coupling Frame',
    albumApply: 'Album image classification',
    albumDec:
      'The similar photos in the album are clustered by clustering algorithm.',
    beautyDec:
      'The appearance level assessment technology scores the input facial images.',
    beautyApply1: 'Beauty Camera',
    beautyApply2: 'Scoring Of Appearance Level',
    recognitionDec:
      'The corresponding gestures of users are obtained through image recognition technology for corresponding operations.',
    recognitionApply: 'lead management',
    reflectiveDec:
      'Determine whether the personnel are wearing reflective clothing through image recognition technology',
    reflectiveApply: 'Construction site Safety management',
    tableApply1: 'Identification of paper-based financial and tax statements',
    tableApply2: 'Identification of paper registration forms',
    control: 'Control Console',
    logout: 'Logout',
    interactive: 'Interactive',
    hot: 'Hot',
    carDec:
      'Classify the specific models of vehicles through image technology.',
    carApply1: 'Vehicle Trading',
    carApply2: 'Smart Auto Insurance',
    smokeDec: 'Analyze and locate the smoke position through image technology.',
    smokeApply1: 'Wildfire Alarm',
    smokeApply2: 'Fire Alarm In The Park',
    plantDec: 'Classify different plants through image technology.',
    plantApply1: 'The State Protects Animals',
    plantApply2: 'Detection Of Agricultural Pests',
    fruitDec:
      'Classify different fruits and vegetables through image technology.',
    fruitApply1: 'Recommendations For Fruit And Vegetable Combinations',
    fruitApply2: 'Statistics Of Nutritional Components',
    foodDec: 'Classify different dishes through image technology.',
    foodApply1: 'Settlement Of Dishes',
    foodApply2: 'Heat Calculation',
    landmarkDec: 'Classify different landmarks through image technology.',
    landmarkApply1: 'Landmark Search',
    landmarkApply2: 'Album Landmark Classification',
    productApply1: 'Take photos to search for products',
    productApply2: 'Find similarities among goods',
    InpaintingApply1: 'Passers-by eliminated',
    InpaintingApply2: 'Watermark removal',
    dehazingApply1: 'Intelligent Driving In Foggy Weather',
    dehazingApply2: 'The Post-processing Of The Photo Went To The Fog',
    colorApply1: 'Beautification Of Design Materials',
    colorApply2: 'Photo Color Grading',
    generationApply1: 'Generation of copywriting illustrations',
    generationApply2: 'logo generator',
    styleApply1: 'Mixed-style image creation',
    styleApply2: 'The picture is oil painted',
    imageDec:
      'Obtain the several elements with the largest proportion in the current picture through image recognition technology.',
    imageApply1: 'User Scenario Judgment',
    oddDec: 'Merge the odd-field and even-field image data into one frame.',
    oddApply: 'Improve The Smoothness Of The Picture',
    handwrittenDec:
      'General character recognition technology can convert handwritten text into editable text.',
    handwrittenApply1: 'Electronicization Of Notes',
    handwrittenApply2: 'Intelligent Marking',
    gestureEmpty: 'No gesture was detected',
    selectGesture:
      'Please reselect and make sure the gesture is directly facing the screen',
    vestEmpty: 'Reflective vests were not detected',
    selectVest:
      'Please reselect and make sure the reflective jacket is directly facing the picture',
    quectelQr: 'Wechat official Account: Quectel',
    personalEmpty: 'No pedestrians were detected',
    selectPersonal:
      'Please reselect and make sure the pedestrian is facing the picture directly',
    depthDec:
      'The distance information of objects in the scene is obtained through image recognition technology.',
    smoking: 'Smoking Detection',
    smokingDec:
      'The technology of recognizing smoking behavior through images.',
    smokingApply: 'Monitoring Of No-smoking Areas',
    smokeEmpty: 'No smoking was detected',
    selectSmoke:
      'Please reselect and make sure the smoking is directly facing the screen',
    speech: 'Speech Recognition',
    synthesis: 'Speech Synthesis',
    voiceprint: 'Voiceprint Recognition',
    animalDec: 'Classify different animals through image technology.',
    animalApply: 'Wildlife detection',
    moution: 'Motion Imaging',
    moutionDec:
      'Electronic image stabilization is a technology that achieves stabilization through software algorithms.',
    moutionApply1: 'Sports Camera',
    moutionApply2: 'Dashcam',
    generator: 'Generative AI',
    textToImage: 'Text to Image',
    LargeLanguage: 'Retrieval-Augmented Generation',
    multiModal: 'Multi-modal',
    imageUnderstand: 'Image Understanding',
    imageSearch: 'Semantic Image Search',
    contactUs: 'Contact Us',
    phoneIncorrect: 'The format of the mobile phone number is incorrect',
    emailIncorrect: 'The email address format is incorrect',
    leave:
      'Please leave your requirements and questions, and we will contact you proactively',
    consultant:
      'Please leave your requirements and questions, and our pre-sales consultant will contact you proactively',
    phone: 'Phone',
    email: 'Email',
    application:
      'Your application scenarios and technical capability requirements',
    company: 'CompanyName',
    submit: 'Submit',
    tellUs: 'Please tell us your requirements and we will contact you',
    transfer: 'Style Transfer',
    imageInpaint: 'Image Inpainting',
    function: 'Function Consultation',
    textToImageDec:
      'Sky City, a castle, Dali, oil painting, graceful feeling, rose colored sky',
    imageToTextDec: 'Please help me find the dog in the picture.',
    suppport: 'Supported platforms',
    smart: 'All Smart platforms',
    vehicleEmpty: 'No vehicle was detected',
    selectVehicle:
      'Please reselect to ensure that the vehicle is directly facing the screen',
    thingEmpty: 'No thing were detected',
    selectThing:
      'Please reselect to ensure that the thing is directly facing the screen',
    techEmpty: 'The repair image cannot be recognized',
    selectTech: 'Please reselect the picture',
    depthApply: 'Unmanned Navigation',
    whiteImage: 'Color Black And White Images',
    whiteImageDec:
      'Algorithms add color to black and white images to make them more vivid.',
    oldPhoto: 'Old Photo Restoration',
    support: 'Technical Support',
    headShoulder: 'Head Shoulder Detection',
    headShoulderDec:
      'Image recognition technology is used to identify the position information of human head and shoulder.',
    headShoulderApply: 'Site Safety Management',
    fireDec: 'Analysis and location of fire source through image technology.',
    fileApply: 'Fire Alarm',
    chatbots: 'Intelligent assistants and chatbots',
    creation: 'Content creation and generation',
  },

  about: {
    title: 'Face Detection',
    description:
      'Detect faces in images or video streams, supports attribute analysis of detected faces.',
    connect: 'Connect Now',
    consult: 'Feature Consultation >',
  },

  footer: {
    productTrial: 'Product Trial',
    contactMessage:
      'Fill out the business requirements form, and we will contact you as soon as possible!',
    sendRequest: 'Send your requirements to us',
    businessCooperation: 'Business Cooperation',
    emailAddress: 'Email Address',
    salesEmail: "qidi{'@'}quectel.com",
    partnerRecruitment: 'Partner Recruitment',
    becomePartner: 'Become a Partner',
    learnMore: 'Learn More',
    logo: 'Quectel Algostore',
    slogan: 'Making AI Detection Simpler',
    products: 'Products',
    oneStopTraining: 'One-stop Training Platform',
    deviceOpenPlatform: 'Device Open Platform',
    aiModelMarket: 'AI Model Market',
    developerTools: 'Developer Tools',
    solutions: 'Solutions',
    smartRetail: 'Smart Retail',
    smartManufacturing: 'Smart Manufacturing',
    smartCity: 'Smart City',
    digitalFinance: 'Digital Finance',
    contactUs: 'Contact Us',
    preSalesConsultation: 'Pre-sales Consultation',
    technicalSupport: 'Technical Support',
    support: 'Technical Support',
    helpDocumentation: 'Help Documentation',
    developerCommunity: 'Developer Community',
    openSource: 'Open Source',
    aboutUs: 'About Us',
    companyIntroduction: 'Company Introduction',
    news: 'News',
    joinUs: 'Join Us',
    aiTrainingPlatform: 'Quectel All Rights Reserved',
    other: 'Other',
    cooperative: 'Cooperative Consultation',
    aboutQuec: 'About Quectel',
    productServices: 'Product and Service',
    module: 'Module and Antenna',
    IOT: 'IoT Platform',
    download: 'Download Zone',
    forum: 'Technical Forum',
    partner: 'Cooperative Partner',
    RD: 'R&D Center',
    PreSale: 'Pre-Sale Consultation',
    cooperator: 'Cooperation Consultation',
    provide:
      'Contact us. Quectel Algostore will continue to provide you with solution consultation',
    or: 'Or',
    leave: 'Leave your information',
    message: 'Your Message',
    developer: 'Developer Center',
  },

  technologies: {
    imageDetection: 'Image Detection',
    imageDetectionDesc: 'Identifying defect locations and quantities',
    imageSegmentation: 'Image Segmentation',
    imageSegmentationDesc:
      'Pixel-level identification of defect locations and contours',
    imageClassification: 'Image Classification',
    imageClassificationDesc: 'Suitable for classifying entire images',
    ocrDetection: 'OCR Text Detection and Recognition',
    ocrDetectionDesc: 'Structured output of text content',
    oneStopTrainingPlatform: 'One-stop Training Platform',
    oneStopTrainingDesc:
      'Supports a one-stop development process including data collection, data labeling, model training, and cloud-edge deployment, aimed at helping users with no background in algorithms to develop scenario-based intelligent algorithms',
    scenarioAI: 'Scenario-based AI needs',
    noAlgorithm: 'Entry without algorithm foundation',
    oneStopModel: 'One-stop model customization',
    enterOneStopPlatform: 'Enter One-stop Training Platform',
    experienceNow: 'Experience Now',
    learnMore: 'Learn More',
    developer: 'Developer Center',
  },

  platformSelect: {
    title: 'Platform Selection',
    description: 'Choose the platform that suits you',
    technicalStrengthTitle: 'TechnicalStrength',
    technicalStrength: {
      algorithmLeading: 'Algorithm As A Service',
      algorithmDescription:
        'Developers can freely combine through a visual interface. Built in automatic hyperparameter tuning engine, increasing model training efficiency by 5 times, supporting full process automation from data annotation to deployment',
      safeStable: 'Safe and Stable',
      safeStableDescription:
        'Years of user and scenario experience accumulation, obtaining multiple management system certifications. Millisecond-level processing speed, high robustness, supporting high concurrency and high availability guarantees',
      wideApplication: 'Computing Power, Hard Power',
      wideApplicationDescription:
        'Support local inference of complex models. Through chip level instruction optimization, achieve zero latency response for high load tasks such as real-time video stream analysis and multi-sensor data fusion',
      easyAccess: 'Model Efficiency Revolution',
      easyAccessDescription:
        'Our self-developed AI algorithm compression engine increases inference speed by 8 times, reduces power consumption by 60%, and empowers edge devices to respond intelligently in real-time',
    },
    items: {
      quickStart: {
        title: 'Quick Start',
        description:
          'No programming experience required, complete model training through simple operations.',
      },
      oneStopService: {
        title: 'One-Stop Service',
        description:
          'Providing a complete solution from data collection to model deployment.',
      },
      safeReliable: {
        title: 'Safe and Reliable',
        description:
          'Data security encryption ensures your business information is protected.',
      },
    },
  },

  landmarks: {
    captcha: 'Captcha',
    captchaRefresh: 'Refresh Captcha',
    captchaInstruction: 'Please enter the captcha',
    captchaRequired: 'Captcha is required',
    confirm: 'Confirm',
    uploadImage: 'Upload Image',
    formatError: 'Please upload JPG/PNG format images',
    sizeError: 'Image file is too large',
    sizeLimit: 'Please keep the image size under 2MB',
    frequentOperation: 'Operation too frequent',
    tryAgain: 'Please try again later',
    noFaceDetected: 'No face detected',
    reselect: 'Please select again, ensure the face is facing the camera',
    customUpload: 'Custom Upload',
    uploadTip: '*Please upload a local image to experience the function.',
    applicationTitle: 'Application Title',
    application1: 'XL-URK',
    serialNumber: 'serial Number',
    content: 'Content',
    live: 'Live Streaming Interaction',
  },

  news: {
    header: 'Company News',
    title1:
      'AI Toy Overall Solution Fully Upgraded: Integrating Volcano Engine RTC Large Model for Real-time Interaction Experience',
    title2:
      'Heavyweight! AIOT Industrial Intelligent Brand Baowita™ and Its Core Products and Solutions Officially Released',
    title3:
      'AIOT Edge Computing Module Successfully Runs DeepSeek Model, Accelerating AI Implementation on the Edge with Leading Engineering Capabilities',
  },

  aiot: {
    title: 'AIoT Products',
    description:
      'Adaptive AI algorithms and modular hardware design are redefining the value boundaries of the Internet of Everything.',
    product1: {
      name: 'MWC large model leads the innovation of service robots',
      desc: 'Assist in achieving various functions such as scenario understanding, knowledge fusion, intelligent interaction, autonomous decision-making, and task execution',
    },
    product2: {
      name: 'Intelligent, Safe, and Efficient: See How Quectel Helps Upgrade Lawnmowers',
      desc: 'Developed an intelligent lawnmower solution for an efficient and safe mowing experience.',
    },
    product3: {
      name: 'SG560D 5G NR Series Intelligent Module',
      desc: 'Widely used in industries and devices such as smart gateways, CPE, MiFi, MID, PND, POS, routers, etc.',
    },
  },

  deploy: {
    enterName: 'Please enter the name',
    selectDevice: 'Please select a device',
    enterDescription: 'Please enter a description',
    addSuccess: 'Added successfully',
    deleteSuccess: 'Deleted successfully',
    addDevice: 'Add Version',
    deviceName: 'Device Name or Version',
    deleteDeviceConfirm: 'Are you sure you want to delete this device?',
    delete: 'Delete',
    name: 'Name',
    deviceID: 'Device ID',
    deviceType: 'Device Type',
    latestLaunchDate: 'Latest Launch Date',
    deviceEmpower: 'Device Empowerment',
    state: 'State',
    description: 'Description',
    action: 'Action',
    deviceSN: 'Device SN',
    select: 'Please select',
    deviceIDPlaceholder: 'Device ID',
    descriptionPlaceholder: 'Description',
    version: 'version',
  },

  common: {
    yes: 'Yes',
    no: 'No',
    supportModule: 'Support Module',
    board: 'Support Development Board',
    ecological: 'Intelligent ecological development board',
  },

  homepage: {
    experienceTitle: 'Experience Title',
    captcha: 'Captcha',
    captchaRefresh: 'Refresh Captcha',
    captchaInstructions: 'Please enter the captcha',
    captchaRequired: 'Captcha is required',
    confirm: 'Confirm',
    uploadImage: 'Upload Image',
    invalidImageFormat: 'Please upload JPG/PNG format images',
    imageTooLarge: 'Image file is too large',
    imageSizeLimit: 'Please keep the image size under 2MB',
    tooFrequent: 'Operation too frequent',
    pleaseTryAgain: 'Please try again later',
    noFaceDetected: 'No face detected',
    pleaseSelectAgain:
      'Please select again, ensure the face is facing the camera',
    customUpload: 'Custom Upload',
    analysis: 'Analysis',
    isSamePerson: 'Is it the same person',
    isSamePet: 'Is it the same pet',
    highProbability: 'High probability',
    lowProbability: 'Low probability',
    uploadTip: '*Please upload a local image to experience the function.',
    applicationTitle: 'Application Title',
    title: 'Welcome to the Official Website',
    experienceTitle: 'Feature Experience',
    feature1: 'Supports Multi-Face Recognition',
    feature2: 'Efficient And Accurate Recognition',
    feature3: 'Supports Real-Time Detection',
    imageText: 'I am an image',
    applicationTitle: 'Application Scenarios',
    application1: 'XL-URK',
    analysis: 'Analysis Result',
    application2: 'Fatigue Monitoring',
    cropText:
      '{num} faces have been detected in the figure. Click the face picture to view the result information',
    cropBodyText:
      '{num} pedestrians in the figure have been detected, click the image to view the result information',
    noPetDetected: 'No Pet Detected',
    pleasePetSelectAgain:
      'Please select again to make sure your pet face is facing the screen',
    qrText:
      '{num} QR code in the figure has been detected. Click the image to view the result information',
    ocrWaterMeterText:
      '{num} water meters in the figure have been detected. Click the water meter image to view the result information',
    ocrText:
      '{num} license plates in the figure have been detected. Click the license plate image to view the result information',
    vehicleText:
      '{num} vehicles in the figure have been detected. Click the image to view the result information',
    imageText:
      '{num} images in the figure have been identified. Click the image to view the result information',
    cropHandText:
      '{num} gestures in the figure have been detected. Click the gesture image to view the result information',
    cropMaskText:
      '{num} masks in the figure have been detected. Click the image to view the result information',
    cropDriverText:
      '{num} driving behaviors in the figure have been detected. Click the picture to view the result information',
    cropHelmetText:
      '{num} helmets in the figure have been detected, click the image to view the result information',
    fire: 'fire Detection',
    imageFireText:
      '{num} flame picture in the image has been identified. Click the picture to view the result information',
    imageGestureText:
      '{num} gesture images in the figure have been recognized. Click on the images to view the result information',
    imageVestText:
      '{num} image of the reflective jacket in the figure has been identified. Click on the image to view the result information',
  },

  messages: {
    uploadImageFormat: 'Please upload JPG/PNG format images',
    imageFileTooLarge: 'Image file is too large',
    imageSizeLimit: 'Please keep the image size under 2MB',
    tooFrequentOperations: 'Operations are too frequent',
    tryAgainLater: 'Please try again later',
    noFaceDetected: 'No face detected',
    reselectImage: 'Please reselect to ensure the face is facing the camera',
    uploadLocalImage:
      '*Please upload a local image to experience the functionality.',
    passenger: 'Passenger Flow Statistics',
    serverBusy: 'The service is busy. Please try again later',
  },

  buttons: {
    confirm: 'Confirm',
    localUpload: 'Local Upload Image',
  },

  faceLandmarks: {
    title: 'Face Landmarks',
    description:
      'Detect key points and positions of facial features, including the outline of the face, eyes, eyebrows, lips, and nose.',
  },

  recognition: {
    faceAge: {
      name: 'Age and Gender',
      dec: 'This is the age and gender description.',
    },
    faceComparison: {
      name: 'Face Comparison',
      dec: 'This is the face comparison description.',
    },
    faceGender: {
      name: 'Gender Recognition',
      dec: 'This is the gender recognition description.',
    },
    faceEmotion: {
      name: 'Emotion Recognition',
      dec: 'This is the emotion recognition description.',
    },
    petComparison: {
      name: 'Pet Comparison',
      dec: 'This is the pet comparison description.',
    },
  },

  audio: {
    dec: 'Real-time separation of human voice and environmental noise, millisecond level processing to ensure sound quality lossless. Adapt to meeting, live broadcast, recording and other scenes, retain the details of human voice, restore clear sound quality, open a pure sound field with one click',
  },

  industry: {
    industry: 'Industry',
    retail: 'Smart Retail',
    retailDec:
      'The recognition algorithm of traditional smart vending cabinets needs to run on cloud servers. A part of the computing power cost is used to cover the usage cost of cloud servers. The edge computing box directly follows the real-time dynamic video stream to calculate the results, which is highly efficient, has no delay, improves the real-time interaction service capability, provides a good user experience, and directly reduces the SIM card data traffic by more than ten times.',
    retailTechnical:
      'The location of the cameras is generally equipped with two cameras, either both at the top or diagonally distributed, but both on the plane where the door is located. When conducting product identification, mainly extract the information within the green rectangular box in the following figure. The on-site lighting, reflection and other factors may affect the quality of the video. The algorithm needs to have sufficient robustness.',
    retailClientTitle: 'Xingyuan vending machine',
    retailClientDec:
      'Quectel Algostore intelligent unmanned retail solution deeply integrates the high-performance 5G AI computing power module SG560D, advanced product recognition algorithms, and innovative new product launch platforms, among other software and hardware services, and possesses powerful dynamic vision and edge computing capabilities. The solution can be seamlessly integrated with the customer application program, providing them with full-stack technical and service support, helping customers achieve cost reduction and efficiency improvement, and promoting the continuous upgrade of the industry towards a smarter and more efficient direction.',
    robot: 'Massage robot',
    robotDec:
      'Sitting for long periods at work and sports injuries have led to a sharp increase in the number of people suffering from muscle strain. Traditional massage equipment has problems such as single techniques and inability to precisely meet individual needs. By leveraging AI large models and flexible robot technology, we create personalized, safe and intelligent massage solutions, covering two major scenarios: home health management and medical rehabilitation. Intelligent pain point identification: By integrating thermal imaging and pressure sensors, it locates muscle stiffness and inflammatory areas. Dynamic manipulation adjustment: Imitating human hand kneading, pressing and patting, the force and rhythm are adapted to the user state in real time. Health Risk Warning: Analyze long-term data to alert early signs of diseases such as cervical spondylosis and lumbar intervertebral disc protrusion. Natural human-computer interaction: Supports voice commands and remote control via APP, and provides health advice.',
    robotClientTitle: 'De Yi Robot',
    robotClientDec:
      'AI large models endow medical robots with "human-like cognition" and "super expert" capabilities, promoting the shift of medical care from an "experience-based" model to a "data + knowledge dual-driven" model, and ultimately achieving precise, inclusive and humanized medical care',
    intelligent: 'Intelligent sorting.',
    intelligentDec:
      'AI visual inspection technology is driving the traditional sorting mode to innovate in the direction of intelligence. Facing industry pain points such as complex categories, non-standard forms, and high environmental sensitivity, traditional manual sorting has limitations such as low efficiency and inconsistent standards. However, the AI vision system based on deep learning shows significant advantages: Combined with the dynamic optical sorting device and through high-precision image recognition algorithms, the appearance features such as fruit diameter texture, color uniformity, and mechanical damage can be analyzed in real time, and hidden defects such as pest and disease infection and maturity deviation can be detected simultaneously.',
    intelligentTechnical:
      'Quectel color selection solution is developed for the industrial material management industry. It adopts the Quectel SG560D intelligent module based on the Qualcomm QCS6490 platform and integrates hardware such as cameras, light sources, and air guns. This solution improves the color sorting results of industrial materials through a visual recognition system combined with capabilities such as machine vision and edge computing, and automatically sorts objects based on color and shape. Its applicable color sorting range includes food raw materials such as rice, wheat, corn, soybeans, seeds, nuts, and salt, plastic products such as plastic parts, plastic pellets, and plastic bottle caps, as well as mineral products such as quartz stone, quartz sand, pearls, and marble. The specific working process of the color sorter equipped with Quectel intelligent color sorting solution is as follows: Materials enter the production line through the hopper, and the terminal visual recognition system monitors the materials and transmits the monitoring data in real time to the AI system. In the AI system, the color, material, size and other data of qualified materials are pre-set. Materials that meet the standards can enter the next quality inspection process. Substandard materials that do not meet the standards will be directly blown away by the air gun, keeping them away from the production line and thus completing color sorting and other tasks. The entire color sorting and quality inspection process is fully automated and does not require manual intervention. Moreover, the terminal also features functions such as automatically adjusting the working parameters of the equipment and remote online operation, creating a solid technical environment for enhancing the performance of automated production lines, achieving efficient data collection and transmission, secure communication, and cost control.',
    intelligentClientTitle: 'Color Sorting',
    intelligentClientDec:
      'Quectel color selection solution is developed for the industrial material management industry. It adopts the Quectel SG560D intelligent module based on the Qualcomm QCS6490 platform and integrates hardware such as cameras, light sources, and air guns. This solution improves the color sorting results of industrial materials through a visual recognition system combined with capabilities such as machine vision and edge computing, and automatically sorts objects based on color and shape. Its applicable color sorting range includes food raw materials such as rice, wheat, corn, soybeans, seeds, nuts, and salt, plastic products such as plastic parts, plastic pellets, and plastic bottle caps, as well as mineral products such as quartz stone, quartz sand, pearls, and marble.',
    scheme: 'Scheme Overview',
    technical: 'Technical Proposal',
    technical1:
      'The specific workflow of color sorting equipped with Quectel intelligent color sorting solution is as follows：',
    technical2:
      'Materials enter the production line through the hopper. The terminal visual recognition system monitors the materials and transmits the monitoring data to the AI system in real time；',
    technical3:
      'In the AI system, the color, material, size and other data of qualified materials are pre-set. Materials that meet the standards can proceed to the next quality inspection process；',
    technical4:
      'Substandard materials that do not meet the standards will be directly blown away by the air gun, keeping them away from the production line and thus completing tasks such as color sorting',
    client: 'Customer Case',
    robot: 'Robotics Industry',
    retailIndustry: 'Retail Industry',
    sortIndustry: 'Intelligent sorting industry',
    pectorophony: 'Voice Enhancement Solution For Intelligent Terminals',
    businessBg: 'Business Background',
    pectorophonyBg:
      'What are those moments of collapse dominated by noise?<br> What?   Speak louder! I can not hear clearly here at all - <br>you must be familiar with these scenes:<br> 1. During the team cycling at the disaster site via walkie-talkie, the key instructions on the walkie-talkie were lost in the wind. On the construction site, the walkie-talkies were filled with the roar of machinery, and the instructions of teammates were completely inaudible. The mutual Shouting in the security walkie-talkies of KTVS and concerts. <br>2. The predicament of dash cams: The conversations recorded by dash cams while driving are drowned out by tire noise, engine sounds, and the wind noise from opening Windows for ventilation. <br>3. The Problem of body-worn Cameras: When police enforce the law, the noisy streets and the commotion of the crowd can turn the recorder recordings into invalid data. The Remote AI voice enhancement solution processes the collected sounds, allowing you to block out noise with just one click and retain only the human voice you want.',
    case: 'related cases',
    pectorophonyScheme:
      'Quecter is AI voice enhancement solution processes the collected audio stream. It first uses signal processing to remove simple noise, then uses AI noise reduction to eliminate complex noise, and then enhances the listening experience to mute non-human voices. Finally, it automatically adjusts the volume through gain to achieve clear and high-quality audio output',
    pectorophonyApplyText1: 'interphone',
    pectorophonyApplyText2: 'body-worn camera',
    pectorophonyCase:
      'Project description: By adopting Quectel module EC800M+AI audio enhancement algorithm, it realizes the voice intercom application of walkie-talkies in complex scenarios such as construction sites and KTVS. Compared with the audio DSP chip previously used by the customer, the cost is reduced by more than twice.',
    robrain: 'Robrain AI Robot solution',
    robrainBg:
      'Embodied intelligence needs to process multi-modal sensor data synchronously. However, edge devices have limited computing power, and cloud transmission suffers from delays, which often lead to lagging action responses or decision-making errors. The Robrain AI robot solution directly addresses the pain points of embodied intelligence. Relying on Quectel is high-computing-power AI modules and the latest miniaturized large models, it breaks through the bottleneck of real-time response through full-stack AI R&D capabilities such as model compression and fine-tuning, truly realizing end-side intelligence. Under the end-cloud collaborative architecture, with the end-side as the mainstay and the cloud as the supplement, it ensures the local processing of sensitive data and builds a solid enterprise-level security barrier. It still maintains 85% of core functions in an offline environment, providing key support for robots to break through scene limitations.',
    robrainScheme:
      '<b> Edge-Cloud Collaborative Architecture Empowers Intelligent Decision-Making </b>: <br><br>The solution is based on Quectel is high-computing-power AI module SG885G, equipped with the Qualcomm QCS8550 processor, providing up to 48 TOPS of NPU computing power to support local large models in achieving low-latency inference.<br>The solution also supports private deployment of exclusive knowledge bases, instruction libraries, and in-depth customization of industry-specific large models, ensuring the security of local data processing. In the networked state, the solution can seamlessly access mainstream cloud-based large models such as Doubao and DeepSeek, as well as professional search tools, endowing TRON 1 with deep semantic understanding and reasoning capabilities and enhancing the level of complex question-and-answer interactions.<br>Meanwhile, the solution adopts an innovative edge-cloud collaborative architecture, which can monitor network status in real-time and intelligently allocate computing resources: key instructions are prioritized for processing on the edge side, while complex tasks are automatically switched to the cloud, ensuring interaction fluency and data security under network fluctuations. This elastic computing power architecture greatly improves the flexibility and cost-effectiveness of robot deployment across scenarios, accelerating the transition of robots from laboratories to industrialization.<br><br><b>Sound Source Localization Technology Ensures Acute Hearing</b><br><br>The solution has achieved significant breakthroughs in building robots multi-modal perception and interaction capabilities, especially in the auditory dimension.<br>The solution integrates multi-microphone array sound pickup technology, combining pre-denoising, echo cancellation, and beamforming algorithms, enabling the robot to accurately locate the direction of sound sources, drive the body to quickly turn to the speaker, and achieve natural interaction of "responding to sound".',
    robot: 'Robot',
    robotCase:
      'Currently, this solution has been successfully implemented in TRON 1, the star product of LimX Dynamics - a multi-form biped robot. It has effectively overcome key challenges such as AI model customization, lightweight deployment, and low-latency interactive response, promoting the robot from "mechanical execution" to an AI agent capable of "active perception, intelligent thinking, and natural communication',
    openVend: 'OpenVending AI Intelligent Recognition Scale Solution',
    openVendBg:
      'Traditional supermarkets and fresh food retail stores face multiple efficiency bottlenecks and experience pain points in the checkout process: fresh products need to be manually coded and labeled at the weighing area first, then queued again at the cash register. During peak hours, the double queuing is time-consuming and prone to congestion; manual operations rely on memorizing product codes, resulting in a long training period for new employees and a high error rate, which easily leads to price disputes; the separation of the weighing and cash register systems causes data asynchronization, making it difficult to control inventory losses; at the same time, labor costs are high, and the setup of weighers and cashiers increases operational burdens. The overall process is cumbersome and inefficient, making it difficult to meet consumers demand for convenient and accurate shopping.<br>To address the above pain points, Quectel has launched the innovative OpenVending AI Intelligent Recognition Scale Solution. Integrating cutting-edge technologies such as "deep learning" and "AI visual algorithms", the solution can realize 0.1-second-level automatic product recognition and seamless payment, completely revolutionizing the traditional weighing process.',
    openVendScheme:
      '<b> Unlocking the "Smart Eye" of AI Recognition </b><br><br>The OpenVending AI solution captures product images through high-precision cameras and utilizes the cross-encoder fusion method of deep learning to accurately extract multi-dimensional features such as product shape, color, and texture, which are then efficiently compared with millions of product images in the database. Thanks to its powerful feature comparison technology, the solution can accurately identify more than 1,000 SKUs with an accuracy rate of up to 99%.<br>For example, when a consumer places a selected mango on the weighing pan, the system intelligently determines whether it is a贵妃 mango or a narcissus mango based on the features such as color, size, shape, and skin texture of the mango captured by the camera, combined with the database. There is no need for manual input of cumbersome PLU codes throughout the process. The system simultaneously obtains the product weight in real-time, quickly completes category identification, unit price matching, and total price calculation, leading to a leap in settlement efficiency.<br>After supermarkets or fresh food retail stores deploy the AI intelligent recognition scale solution, clerks can get rid of inefficient and complicated weighing and pricing work, and instead focus on key links such as packaging, sorting, and customer service, significantly optimizing operational efficiency.<br>At the same time, the solution integrates machine learning technology. By continuously learning and analyzing historical data, it constantly expands its predictive capabilities, which can be called the "most powerful brain" in the field of retail weighing.<br><br><b>0.1 Seconds to Unlock the Era of Ultra-Fast Shopping</b><br><br>Currently, OpenVending has taken the lead in achieving deployment on Quectel is high-performance SG560D 5G+AI intelligent module. According to actual tests, the process of product recognition and pricing can be completed in a flash within 0.1 seconds, with efficiency far exceeding that of traditional methods.<br>In addition to the SG560D module, the solution is also widely compatible with various AI intelligent modules developed by Quectel based on multiple computing power platforms. Customers can flexibly select and configure modules according to their actual needs such as retail business scale and site environment.<br><br><b>Intelligent Evolution Never Stops: Flexible Adaptation and Continuous Upgrading</b><br><br>After in-depth training with massive amounts of data, Quectel is OpenVending AI intelligent recognition scale solution has demonstrated excellent model generalization ability. At the same time, it can flexibly provide models of different sizes (large, medium, and small) to accurately match the needs of various actual application scenarios. In addition, the solution supports regular online seamless upgrading of the model, continuously expanding the boundary of identifiable commodity types to meet the dynamic changes of the market.',
    openVendCase:
      'Tianbo Intelligent Recognition Scale: The AI intelligent recognition scale is not only a powerful tool for enhancing retail efficiency but also a key digital infrastructure for reconfiguring the relationship between "people, goods, and places". From supermarkets to farmers markets, from the weighing process to full-chain operations, this AI-driven "revolution on scales" is redefining the future landscape of the retail industry. As a leader in the global Internet of Things (iot) overall solution field, Quectel will walk hand in hand with industry customers to jointly revolutionize the infinite possibilities of smart retail experiences.',
    supermarkets: 'supermarkets',
    store: 'fresh food retail stores',
    tianbo: 'Tianbo Intelligent Recognition scale',

    voiceAssistant: 'AI Voice Assistant Solution',
    voiceAssistantBg:
      'The exceptional interactive experience of AI voice assistants relies on advanced audio algorithms. In this solution, by integrating module hardware with end-to-end audio algorithms and combining the "intelligent brain" of cloud-based large models, AI voice assistants can "hear" users acutely and "understand" them accurately.',
    voiceAssistantScheme:
      'In complex environments, the Audio Noise Suppression (ANS) algorithm effectively filters out background noise, enabling toys to clearly capture users voices; the Acoustic Echo Cancellation (AEC) algorithm ensures that when toys play voices, the speaker sounds picked up by microphones can be effectively removed to avoid interference; the Voice Activity Detection (VAD) algorithm accurately identifies voice activities, and when combined with the Keyword Spotting (KWS) algorithm, it achieves rapid wake-up and command recognition, significantly improving interaction efficiency. Even in noisy environments, these algorithms can ensure that AI toys accurately recognize users voice commands, bringing a smooth interactive experience. For example, in noisy scenarios such as family gatherings, AI toys can still be accurately woken up and understand commands.',
    voiceAssistantCaseTitle: 'Aofei Entertainment',
    voiceAssistantCaseDec:
      'The "AI Smart Fun Happy Sheep 2.0" of Playpoint Unlimited is equipped with Quectel is 4G version of the AI toy overall solution and is built on the EC800M-CN 4G module. It transforms "Happy Sheep" from a static doll into an AI intelligent entity that can "listen, speak, understand emotions and grow", redefining the technical benchmark of the trendy toy industry.',
    voiceTerminal: 'Voice Terminal',
    Intelligent: 'Intelligent Industry',

    massageRobot: 'Massage Robot Solution',
    intelligentVending: 'Intelligent Vending Cabinet Solution',
    terminalEnhancement: 'Terminal enhancement solution',
    IntelligentSorting: 'Intelligent Sorting Solution',
    toy: 'Plush Toy',
    base: 'Intelligent base',
    learning: 'AI learning camera',
    desktop: 'Desktop robot',
  },
}

export default localeValues
